import React, { useState, useEffect } from 'react';
import './CBSEApplicationForm.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Preloader from '../../../components/Preloader/Preloader';
import { mockOpenJobs } from '../../../AppData';

const config = require('../../../config.json');

export default function CBSEApplicationForm(props) {
  const { setActiveKey, selectedJob } = props;
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [loaded, setLoaded] = useState(true);
  const [photoPreviewUrl, setPhotoPreviewUrl] = useState(null);

  const [formData, setFormData] = useState({
    postApplied: '', appliedSchool: '', appliedSubject: '',
    schoolName: '', appliedSchoolID: '', jobPostingID: '',
    applicantName: '', gender: 'Male',
    subject: '',
    educationalQualification: '',
    emailID: '',
    fatherName: '',
    motherName: '',
    spouseName: '',
    dateOfBirth: '',
    currentAddress: '',
    permanentAddress: '',
    currentDesignationandDepartment: '',
    scoreInTETCTET: '',
    tetCleared: 'No',
    aadharNo: '',
    previousSchoolUANNO: '',
    previousSchoolESINo: '',
    pfNo: '',
    lastDrawnSalary: '',
    expectedSalary: '',
    phoneNumber: '',
    reference1Name: '',
    reference1ContactNo: '',
    reference1Designation: '',
    reference2Name: '',
    reference2ContactNo: '',
    reference2Designation: '',
    expectedDateofJoining: '',
    pgDegree: '',
    pgUniversity: '',
    pgMedium: 'English',
    pgYearOfPassing: '',
    pgPercentage: '',
    ugDegree: '',
    ugUniversity: '',
    ugMedium: 'English',
    ugYearOfPassing: '',
    ugPercentage: '',
    class12School: '',
    class12Institute: '',
    class12Medium: 'English',
    class12YearOfPassing: '',
    class12Percentage: '',
    class10School: '',
    class10Institute: '',
    class10Medium: 'English',
    class10YearOfPassing: '',
    class10Percentage: '',
    terms: false
  });

  const [workExperience, setWorkExperience] = useState([
    {
      id: 1,
      institutionName: '',
      fromDate: '',
      toDate: '',
      years: '',
      designation: '',
      reasonForLeaving: '',
    },
  ]);

  const [files, setFiles] = useState({
    userPhoto: null,
    ugCertificate: null,
    bedCertificate: null,
    aadharCopy: null,
  });

  const [fileNames, setFileNames] = useState({
    userPhoto: '',
    ugCertificate: '',
    bedCertificate: '',
    aadharCopy: '',
  });

  const [genderData, setGenderData] = useState([{ id: 1, value: "Male" }, { id: 2, value: "Female" }]);
  const [errors, setErrors] = useState({});
  const [info, setInfo] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [isInitiatingPhonePe, setIsInitiatingPhonePe] = useState(false);
  const [isProcessingOrder, setIsProcessingOrder] = useState(false);

  useEffect(() => {
    if (mockOpenJobs.length > 0) {
      initializeForm();
      window.scrollTo(0, 0);
    }
  }, [selectedJob]);

  const initializeForm = () => {
    const job = selectedJob || mockOpenJobs[0];
    const genderOptions = [{ id: 1, value: "Male" }, { id: 2, value: "Female" }];
    let filteredGender = genderOptions;

    if (job?.gender === 'Female') {
      filteredGender = genderOptions.filter(option => option.value === 'Female');
    } else if (job?.gender === 'Male') {
      filteredGender = genderOptions.filter(option => option.value === 'Male');
    }
    setGenderData(filteredGender);

    setFormData(prev => ({
      ...prev,
      appliedPost: job.positionApplied || '',
      appliedSubject: job.subject || '',
      schoolName: job.schoolName || '',
      appliedSchoolID: job.appliedSchoolID || '',
      jobPostingID: job.jobPostingID || '',
      gender: filteredGender[0]?.value || 'Male',
    }));
  };

  const handlePostChange = (inputValue) => {
    const tValue = mockOpenJobs.find(job => job.jobPostingID === inputValue);
    if (!tValue) return;

    const genderOptions = [{ id: 1, value: "Male" }, { id: 2, value: "Female" }];
    let filteredGender = genderOptions;
    if (tValue.gender === 'Female') {
      filteredGender = genderOptions.filter(option => option.value === 'Female');
    } else if (tValue.gender === 'Male') {
      filteredGender = genderOptions.filter(option => option.value === 'Male');
    }
    setGenderData(filteredGender);

    setFormData(prev => ({
      ...prev,
      appliedPost: tValue.positionApplied,
      schoolName: tValue.schoolName,
      appliedSchoolID: tValue.appliedSchoolID,
      jobPostingID: tValue.jobPostingID,
      appliedSubject: tValue.subject,
      gender: filteredGender[0]?.value || 'Male'
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleWorkExperienceChange = (id, field, value) => {
    setWorkExperience(prevExperience =>
      prevExperience.map(exp => {
        if (exp.id === id) {
          const updatedExp = { ...exp, [field]: value };
          if ((field === 'fromDate' || field === 'toDate') && updatedExp.fromDate && updatedExp.toDate) {
            const from = new Date(updatedExp.fromDate);
            const to = new Date(updatedExp.toDate);
            const years = ((to - from) / (1000 * 60 * 60 * 24 * 365.25)).toFixed(1);
            updatedExp.years = Number(years) > 0 ? years : '0';
          }
          return updatedExp;
        }
        return exp;
      })
    );
  };

  const addWorkExperience = () => {
    const newId = Math.max(...workExperience.map(exp => exp.id), 0) + 1;
    setWorkExperience(prev => [
      ...prev,
      {
        id: newId,
        institutionName: '',
        fromDate: '',
        toDate: '',
        years: '',
        designation: '',
        reasonForLeaving: '',
      },
    ]);
  };

  const removeWorkExperience = (id) => {
    if (workExperience.length > 1) {
      setWorkExperience(prev => prev.filter(exp => exp.id !== id));
    }
  };

  const handleFileChange = (e, fileType) => {
    const file = e.target.files[0];
    if (file) {
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        alert('File size must be less than 5MB');
        e.target.value = '';
        return;
      }
      if (fileType === 'userPhoto') {
        const preview = URL.createObjectURL(file);
        setPhotoPreviewUrl(preview);
      }
      setFiles(prev => ({ ...prev, [fileType]: file }));
      setFileNames(prev => ({ ...prev, [fileType]: file.name }));
      if (errors[fileType]) {
        setErrors(prev => ({ ...prev, [fileType]: '' }));
      }
    }
  };

  const removeFile = (fileType) => {
    if (fileType === 'userPhoto') {
      setPhotoPreviewUrl(null);
    }
    setFiles(prev => ({ ...prev, [fileType]: null }));
    setFileNames(prev => ({ ...prev, [fileType]: '' }));
    const fileInput = document.getElementById(`file-${fileType}`);
    if (fileInput) fileInput.value = '';
  };

  // Step-by-Step Form Validation
  const validateStep = (step) => {
    const newErrors = {};

    if (step === 1) {
      if (!formData.applicantName.trim()) newErrors.applicantName = 'Applicant Name is required';
      if (!formData.emailID.trim()) {
        newErrors.emailID = 'Email Address is required';
      } else if (!/\S+@\S+\.\S+/.test(formData.emailID)) {
        newErrors.emailID = 'Valid Email Address is required';
      }
      if (!formData.phoneNumber.trim()) {
        newErrors.phoneNumber = 'Contact Number is required';
      } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
        newErrors.phoneNumber = 'Contact Number must be 10 digits';
      }
      if (!formData.dateOfBirth) newErrors.dateOfBirth = 'Date of Birth is required';
      if (!formData.aadharNo.trim()) {
        newErrors.aadharNo = 'Aadhar Number is required';
      } else if (!/^\d{12}$/.test(formData.aadharNo.replace(/\s+/g, ''))) {
        newErrors.aadharNo = 'Aadhar Number must be 12 digits';
      }
      if (!formData.fatherName.trim()) newErrors.fatherName = "Father's Name is required";
      if (!formData.motherName.trim()) newErrors.motherName = "Mother's Name is required";
    }

    if (step === 2) {
      if (!formData.educationalQualification.trim()) newErrors.educationalQualification = 'Qualification is required';
      if (!formData.subject.trim()) newErrors.subject = 'Subject is required';
      if (!formData.currentDesignationandDepartment.trim()) newErrors.currentDesignationandDepartment = 'Current designation is required';

      // UG Validation
      if (!formData.ugDegree.trim()) newErrors.ugDegree = 'UG Degree is required';
      if (!formData.ugUniversity.trim()) newErrors.ugUniversity = 'UG University is required';
      if (!formData.ugMedium.trim()) newErrors.ugMedium = 'UG Medium is required';
      if (!formData.ugYearOfPassing) newErrors.ugYearOfPassing = 'UG Year of Passing is required';
      if (!formData.ugPercentage) newErrors.ugPercentage = 'UG Percentage is required';

      // 12th Validation
      if (!formData.class12School.trim()) newErrors.class12School = '12th Board Name is required';
      if (!formData.class12Institute.trim()) newErrors.class12Institute = '12th School Name is required';
      if (!formData.class12Medium.trim()) newErrors.class12Medium = '12th Medium is required';
      if (!formData.class12YearOfPassing) newErrors.class12YearOfPassing = '12th Year of Passing is required';
      if (!formData.class12Percentage) newErrors.class12Percentage = '12th Percentage is required';

      // 10th Validation
      if (!formData.class10School.trim()) newErrors.class10School = '10th Board Name is required';
      if (!formData.class10Institute.trim()) newErrors.class10Institute = '10th School Name is required';
      if (!formData.class10Medium.trim()) newErrors.class10Medium = '10th Medium is required';
      if (!formData.class10YearOfPassing) newErrors.class10YearOfPassing = '10th Year of Passing is required';
      if (!formData.class10Percentage) newErrors.class10Percentage = '10th Percentage is required';
    }

    if (step === 3) {
      if (!formData.expectedSalary) newErrors.expectedSalary = 'Expected Salary is required';
      if (!formData.expectedDateofJoining) newErrors.expectedDateofJoining = 'Expected Joining Date is required';
    }

    if (step === 4) {
      if (!files.userPhoto) newErrors.userPhoto = 'Candidate Photograph is required';
      if (!files.aadharCopy) newErrors.aadharCopy = 'Aadhar Card copy is required';
      if (!files.ugCertificate) newErrors.ugCertificate = 'UG Certificate copy is required';
    }

    if (step === 5) {
      if (!formData.terms) newErrors.terms = 'Please accept the declaration before proceeding to payment';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => Math.min(prev + 1, 5));
      window.scrollTo({ top: 300, behavior: 'smooth' });
    }
  };

  const handlePrevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
    window.scrollTo({ top: 300, behavior: 'smooth' });
  };

  function getApplicationCode(applicationName) {
    if (!applicationName) return "CBSE";
    const words = applicationName.trim().split(/\s+/);
    if (words.length === 1) return words[0].substring(0, 4).toUpperCase();
    return (words[0].substring(0, 2) + words[1].substring(0, 2)).toUpperCase();
  }

  const generateUniqueId = () => {
    const now = new Date();
    const name = formData.applicantName;
    const appCode = getApplicationCode(name);
    const yy = now.getFullYear().toString().slice(-2);
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    const ss = String(now.getSeconds()).padStart(2, '0');
    const ms = String(now.getMilliseconds()).padStart(3, '0');
    return `${appCode}${yy}${mm}${dd}${hh}${min}${ss}${ms}`;
  };

  const generateDate = () => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  function getFileExtension(filename) {
    if (!filename) return '';
    const index = filename.lastIndexOf('.');
    return index !== -1 ? filename.slice(index) : '';
  }

  const postOnS3 = async (staffID, schoolID, file, targetFilenameWithoutExt) => {
    if (!file) return;
    try {
      const fileType = file.type;
      const extension = getFileExtension(file.name);
      const newFileName = targetFilenameWithoutExt + extension;
      const blob = file.slice(0, file.size, fileType);
      const newFile = new File([blob], newFileName, { type: fileType });
      const bucketName = config.s3.bucketName;
      const keyName = `staff/cbse/${schoolID}/${staffID}/profile`;

      const response = await axios.get(
        `${config.api.invokeURL}/image/presigned/uploader?fileName=${newFileName}&bucketName=${bucketName}&fileType=${fileType}&keyName=${keyName}`,
        { headers: { 'x-api-key': config.api.key } }
      );

      if (response?.data?.uploadURL) {
        await fetch(response.data.uploadURL, {
          method: 'PUT',
          headers: { 'Content-Type': fileType },
          body: newFile,
        });
      }
    } catch (error) {
      console.error('Error uploading file to S3:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateStep(5)) return;

    setLoaded(false);
    try {
      const tapplicantID = generateUniqueId();
      const tdate = generateDate();

      const photoExt = getFileExtension(files.userPhoto?.name);
      const aadharExt = getFileExtension(files.aadharCopy?.name);
      const ugExt = getFileExtension(files.ugCertificate?.name);
      const bedExt = getFileExtension(files.bedCertificate?.name);

      const tphotoCopy = files.userPhoto ? `${tapplicantID}${photoExt}` : null;
      const taadharCopy = files.aadharCopy ? `${tapplicantID}_aadhar${aadharExt}` : null;
      const tugCertificate = files.ugCertificate ? `${tapplicantID}_ugcertificate${ugExt}` : null;
      const tbedCertificate = files.bedCertificate ? `${tapplicantID}_bedcertificate${bedExt}` : null;

      const params = {
        ...formData,
        applicationID: tapplicantID,
        staffID: tapplicantID,
        applicationStatus: "Active",
        workExperience: workExperience,
        files: {
          userPhoto: tphotoCopy,
          ugCertificate: tugCertificate,
          bedCertificate: tbedCertificate,
          aadharCopy: taadharCopy,
        },
        updatedBy: formData.applicantName,
        updatedOn: tdate,
        dateApplied: tdate,
        jobCategory: "CBSE"
      };

      const response = await axios.post(`${config.api.invokeURL}/staff/cbseapplications`, params, {
        headers: { 'x-api-key': config.api.key }
      });

      if (response.status === 201) {
        // Upload all selected documents with synchronous key mapping
        if (files.userPhoto) {
          await postOnS3(tapplicantID, formData.appliedSchoolID, files.userPhoto, tapplicantID);
        }
        if (files.aadharCopy) {
          await postOnS3(tapplicantID, formData.appliedSchoolID, files.aadharCopy, `${tapplicantID}_aadhar`);
        }
        if (files.ugCertificate) {
          await postOnS3(tapplicantID, formData.appliedSchoolID, files.ugCertificate, `${tapplicantID}_ugcertificate`);
        }
        if (files.bedCertificate) {
          await postOnS3(tapplicantID, formData.appliedSchoolID, files.bedCertificate, `${tapplicantID}_bedcertificate`);
        }

        setSubmitted(true);
        setLoaded(true);
        handlePhonePePayment(params);
      } else {
        setInfo("You have already applied for this Open Position! Go to the Print tab to view your application.");
        setLoaded(true);
      }
    } catch (error) {
      console.error('Submission Error:', error);
      setErrorMessage(error?.response?.data?.message || 'Failed to submit application. Please try again.');
      setLoaded(true);
    }
  };

  const handlePhonePePayment = async (applicationData) => {
    if (isInitiatingPhonePe || isProcessingOrder) return;

    try {
      setErrorMessage('');
      setStatusMessage('Connecting to PhonePe Secure Gateway. Please wait...');
      setIsInitiatingPhonePe(true);

      const apiBase = config?.api?.invokeURL;
      if (!apiBase) throw new Error('API configuration is missing invokeURL.');

      const orderAmount = 200;
      const todayDate = new Date().toISOString();
      const clientID = 'MDUEDN';

      const paymentPayload = {
        clientID: clientID,
        jobPostingID: applicationData.jobPostingID,
        orderId: applicationData.applicationID,
        orderRefId: applicationData.applicationID,
        referenceId: 'NA',
        orderType: 'New',
        txStatus: applicationData.applicationStatus,
        paymentMode: 'phonepe',
        txMsg: 'Application registration fee',
        txTime: todayDate,
        orderAmount: orderAmount.toString(),
        pocName: applicationData.applicantName,
        pocEmail: applicationData.emailID,
        pocPhone: applicationData.phoneNumber,
        pocAddress: applicationData.currentAddress || 'Tamil Nadu',
        transactionDate: todayDate,
        discountAmount: 0,
        discountValue: 0,
        discountCode: 'NA',
        subTotal: orderAmount,
        gstCharges: 0,
        paymentPartner: 'phonepe',
        cart: "Application Fee",
      };

      const res = await axios.post(`${apiBase}/transaction/phonepev2/checkout`, paymentPayload, {
        headers: { 'x-api-key': config.api.key },
      });

      const updatedAppData = {
        ...applicationData,
        merchantOrderId: res.data.merchantOrderId,
        clientID: clientID,
        orderAmount: orderAmount,
        applicationStatus: 'Pending Payment'
      };
      sessionStorage.setItem('currentApplication', JSON.stringify(updatedAppData));

      const redirectUrl = res.data?.phonepeResponse?.redirectUrl;
      if (!redirectUrl) throw new Error('PhonePe redirect URL is missing in API response.');

      const callback = async (response) => {
        if (response === 'USER_CANCEL') {
          setErrorMessage('Payment was cancelled. You can retry paying anytime via Track Status.');
          setIsInitiatingPhonePe(false);
          return;
        }

        if (response === 'CONCLUDED') {
          setIsProcessingOrder(true);
          setStatusMessage('Processing payment confirmation...');
          try {
            await handleOrderStatusUpdate(res.data.merchantOrderId);
            navigate('/application/payment-status');
          } catch (err) {
            navigate('/application/payment-status');
          }
        }
      };

      if (window?.PhonePeCheckout?.transact && typeof window.PhonePeCheckout.transact === 'function') {
        window.PhonePeCheckout.transact({ tokenUrl: redirectUrl, callback, type: 'IFRAME' });
      } else {
        window.location.href = redirectUrl;
      }
    } catch (error) {
      console.error('PhonePe error:', error);
      setErrorMessage(error?.response?.data?.message || error?.message || 'Unable to initiate PhonePe payment.');
      setIsInitiatingPhonePe(false);
      setIsProcessingOrder(false);
    }
  };

  const handleOrderStatusUpdate = async (merchantOrderId) => {
    try {
      const apiBase = config?.api?.invokeURL;
      const res = await axios.get(`${apiBase}/transaction/phonepev2/order-status?merchantOrderId=${merchantOrderId}`, {
        headers: { 'x-api-key': config.api.key },
      });
      if (res.data?.status) {
        const saved = sessionStorage.getItem('currentApplication');
        if (saved) {
          const parsed = JSON.parse(saved);
          parsed.applicationStatus = res.data.status;
          sessionStorage.setItem('currentApplication', JSON.stringify(parsed));
        }
      }
    } catch (err) {
      console.error('Error updating order status:', err);
    }
  };

  const resetForm = () => {
    initializeForm();
    setCurrentStep(1);
    setPhotoPreviewUrl(null);
    setWorkExperience([
      {
        id: 1,
        institutionName: '',
        fromDate: '',
        toDate: '',
        years: '',
        designation: '',
        reasonForLeaving: '',
      },
    ]);
    setFiles({
      userPhoto: null,
      ugCertificate: null,
      bedCertificate: null,
      aadharCopy: null,
    });
    setFileNames({
      userPhoto: '',
      ugCertificate: '',
      bedCertificate: '',
      aadharCopy: '',
    });
    setErrors({});
    setSubmitted(false);
  };

  return (
    <div className="cbse-application-container">
      {!loaded && <Preloader show={true} />}

      <div className="cbse-form-wrapper">
        {/* Banner Header */}
        <div className="form-header-banner">
          <div className="form-header-badge">CBSE Staff Recruitment 2026-27</div>
          <h1 className="form-title">Online Job Application Portal</h1>
          <p className="form-subtitle">Please complete all 5 steps to submit your application and finalize payment</p>
        </div>

        {/* 5-Step Progress Stepper */}
        <div className="stepper-container">
          <div className="stepper-track">
            <div className="stepper-progress-line">
              <div
                className="stepper-progress-fill"
                style={{ width: `${((currentStep - 1) / 4) * 100}%` }}
              ></div>
            </div>

            {[
              { num: 1, label: 'Personal Info' },
              { num: 2, label: 'Education' },
              { num: 3, label: 'Experience' },
              { num: 4, label: 'Documents' },
              { num: 5, label: 'Review & Pay' },
            ].map(step => (
              <button
                key={step.num}
                type="button"
                className={`stepper-step ${currentStep === step.num ? 'active' : ''} ${currentStep > step.num ? 'completed' : ''}`}
                onClick={() => {
                  if (step.num < currentStep) setCurrentStep(step.num);
                  else if (validateStep(currentStep)) setCurrentStep(step.num);
                }}
              >
                <div className="step-circle">
                  {currentStep > step.num ? '✓' : step.num}
                </div>
                <div className="step-label">{step.label}</div>
              </button>
            ))}
          </div>
        </div>

        <form onSubmit={handleSubmit} className="cbse-form">
          {/* ================= STEP 1: PERSONAL & CONTACT DETAILS ================= */}
          {currentStep === 1 && (
            <div className="form-section-card">
              <div className="section-legend-box">
                <div className="section-icon">👤</div>
                <div className="section-heading-text">
                  <h3>Step 1: Position & Personal Information</h3>
                  <p>Choose your target position and enter your identity details</p>
                </div>
              </div>

              {/* Target Post Selection */}
              <div className="highlight-card">
                <h4 className="highlight-card-title">📌 Selected Teaching Opening</h4>
                <div className="form-group">
                  <label htmlFor="postApplied">Post & Subject Applied <span className="req-star">*</span></label>
                  <select
                    id="postApplied"
                    name="postApplied"
                    value={formData.jobPostingID}
                    onChange={e => handlePostChange(e.target.value)}
                    className="form-select-custom"
                  >
                    {mockOpenJobs.map((item, index) => (
                      <option key={index} value={item.jobPostingID}>
                        {item.positionApplied} - {item.subject} ({item.schoolName}, {item.workLocation})
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Personal Details Row 1 */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="applicantName">Full Name (As per Certificates) <span className="req-star">*</span></label>
                  <input
                    type="text"
                    id="applicantName"
                    name="applicantName"
                    value={formData.applicantName}
                    onChange={handleInputChange}
                    className={`form-control-custom ${errors.applicantName ? 'input-error' : ''}`}
                    placeholder="Enter candidate full name"
                  />
                  {errors.applicantName && <span className="error-message">{errors.applicantName}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="gender">Gender <span className="req-star">*</span></label>
                  <select
                    id="gender"
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                    className="form-select-custom"
                  >
                    {genderData.map((item, index) => (
                      <option key={index} value={item.value}>{item.value}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Personal Details Row 2 */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="emailID">Email Address <span className="req-star">*</span></label>
                  <input
                    type="email"
                    id="emailID"
                    name="emailID"
                    value={formData.emailID}
                    onChange={handleInputChange}
                    className={`form-control-custom ${errors.emailID ? 'input-error' : ''}`}
                    placeholder="name@example.com"
                  />
                  {errors.emailID && <span className="error-message">{errors.emailID}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="phoneNumber">Mobile / Contact Number <span className="req-star">*</span></label>
                  <input
                    type="tel"
                    id="phoneNumber"
                    name="phoneNumber"
                    maxLength={10}
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    className={`form-control-custom ${errors.phoneNumber ? 'input-error' : ''}`}
                    placeholder="10 digit mobile number"
                  />
                  {errors.phoneNumber && <span className="error-message">{errors.phoneNumber}</span>}
                </div>
              </div>

              {/* Personal Details Row 3 */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="dateOfBirth">Date of Birth <span className="req-star">*</span></label>
                  <input
                    type="date"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleInputChange}
                    className={`form-control-custom ${errors.dateOfBirth ? 'input-error' : ''}`}
                  />
                  {errors.dateOfBirth && <span className="error-message">{errors.dateOfBirth}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="aadharNo">Aadhar Card Number <span className="req-star">*</span></label>
                  <input
                    type="text"
                    id="aadharNo"
                    name="aadharNo"
                    maxLength={12}
                    value={formData.aadharNo}
                    onChange={handleInputChange}
                    className={`form-control-custom ${errors.aadharNo ? 'input-error' : ''}`}
                    placeholder="12 digit Aadhar number"
                  />
                  {errors.aadharNo && <span className="error-message">{errors.aadharNo}</span>}
                </div>
              </div>

              {/* Family Details */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="fatherName">Father's Name <span className="req-star">*</span></label>
                  <input
                    type="text"
                    id="fatherName"
                    name="fatherName"
                    value={formData.fatherName}
                    onChange={handleInputChange}
                    className={`form-control-custom ${errors.fatherName ? 'input-error' : ''}`}
                    placeholder="Enter father's name"
                  />
                  {errors.fatherName && <span className="error-message">{errors.fatherName}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="motherName">Mother's Name <span className="req-star">*</span></label>
                  <input
                    type="text"
                    id="motherName"
                    name="motherName"
                    value={formData.motherName}
                    onChange={handleInputChange}
                    className={`form-control-custom ${errors.motherName ? 'input-error' : ''}`}
                    placeholder="Enter mother's name"
                  />
                  {errors.motherName && <span className="error-message">{errors.motherName}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group full-width">
                  <label htmlFor="spouseName">Spouse Name (If Married)</label>
                  <input
                    type="text"
                    id="spouseName"
                    name="spouseName"
                    value={formData.spouseName}
                    onChange={handleInputChange}
                    className="form-control-custom"
                    placeholder="Enter spouse name"
                  />
                </div>
              </div>

              {/* Address Details */}
              <div className="form-row">
                <div className="form-group full-width">
                  <label htmlFor="currentAddress">Current Residential Address</label>
                  <input
                    type="text"
                    id="currentAddress"
                    name="currentAddress"
                    value={formData.currentAddress}
                    onChange={handleInputChange}
                    className="form-control-custom"
                    placeholder="Door No, Street Name, City, Pincode"
                  />
                </div>
              </div>
            </div>
          )}

          {/* ================= STEP 2: EDUCATIONAL QUALIFICATIONS ================= */}
          {currentStep === 2 && (
            <div className="form-section-card">
              <div className="section-legend-box">
                <div className="section-icon">🎓</div>
                <div className="section-heading-text">
                  <h3>Step 2: Educational & Professional Qualifications</h3>
                  <p>Provide your complete academic history starting from secondary school to master's degree</p>
                </div>
              </div>

              {/* Summary Qualifications */}
              <div className="highlight-card">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="educationalQualification">Highest Degree / Qualification <span className="req-star">*</span></label>
                    <input
                      type="text"
                      id="educationalQualification"
                      name="educationalQualification"
                      value={formData.educationalQualification}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.educationalQualification ? 'input-error' : ''}`}
                      placeholder="e.g. M.Sc, B.Ed"
                    />
                    {errors.educationalQualification && <span className="error-message">{errors.educationalQualification}</span>}
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Major / Specialization Subject <span className="req-star">*</span></label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.subject ? 'input-error' : ''}`}
                      placeholder="e.g. Mathematics, English, Physics"
                    />
                    {errors.subject && <span className="error-message">{errors.subject}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="tetCleared">Cleared TET / CTET?</label>
                    <select
                      id="tetCleared"
                      name="tetCleared"
                      value={formData.tetCleared}
                      onChange={handleInputChange}
                      className="form-select-custom"
                    >
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </select>
                  </div>

                  {formData.tetCleared === 'Yes' && (
                    <div className="form-group">
                      <label htmlFor="scoreInTETCTET">TET / CTET Score</label>
                      <input
                        type="number"
                        id="scoreInTETCTET"
                        name="scoreInTETCTET"
                        value={formData.scoreInTETCTET}
                        onChange={handleInputChange}
                        className="form-control-custom"
                        placeholder="Enter score"
                      />
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="currentDesignationandDepartment">Current Designation & Dept <span className="req-star">*</span></label>
                    <input
                      type="text"
                      id="currentDesignationandDepartment"
                      name="currentDesignationandDepartment"
                      value={formData.currentDesignationandDepartment}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.currentDesignationandDepartment ? 'input-error' : ''}`}
                      placeholder="e.g. PRT Teacher, Mathematics"
                    />
                    {errors.currentDesignationandDepartment && <span className="error-message">{errors.currentDesignationandDepartment}</span>}
                  </div>
                </div>
              </div>

              {/* Undergraduate (UG) */}
              <div className="education-level-card">
                <h4>1. Undergraduate (UG) Degree <span className="req-star">*</span></h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Degree Name <span className="req-star">*</span></label>
                    <input
                      type="text"
                      name="ugDegree"
                      value={formData.ugDegree}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.ugDegree ? 'input-error' : ''}`}
                      placeholder="e.g. B.Sc, B.A, B.Com"
                    />
                    {errors.ugDegree && <span className="error-message">{errors.ugDegree}</span>}
                  </div>

                  <div className="form-group">
                    <label>University / College <span className="req-star">*</span></label>
                    <input
                      type="text"
                      name="ugUniversity"
                      value={formData.ugUniversity}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.ugUniversity ? 'input-error' : ''}`}
                      placeholder="University Name"
                    />
                    {errors.ugUniversity && <span className="error-message">{errors.ugUniversity}</span>}
                  </div>
                </div>

                <div className="form-row three-cols">
                  <div className="form-group">
                    <label>Medium <span className="req-star">*</span></label>
                    <select
                      name="ugMedium"
                      value={formData.ugMedium}
                      onChange={handleInputChange}
                      className="form-select-custom"
                    >
                      <option value="English">English</option>
                      <option value="Tamil">Tamil</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Year of Passing <span className="req-star">*</span></label>
                    <input
                      type="number"
                      name="ugYearOfPassing"
                      value={formData.ugYearOfPassing}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.ugYearOfPassing ? 'input-error' : ''}`}
                      placeholder="YYYY"
                      min="1970"
                      max={new Date().getFullYear()}
                    />
                    {errors.ugYearOfPassing && <span className="error-message">{errors.ugYearOfPassing}</span>}
                  </div>
                  <div className="form-group">
                    <label>Percentage / CGPA <span className="req-star">*</span></label>
                    <input
                      type="number"
                      step="0.01"
                      name="ugPercentage"
                      value={formData.ugPercentage}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.ugPercentage ? 'input-error' : ''}`}
                      placeholder="e.g. 78.5"
                    />
                    {errors.ugPercentage && <span className="error-message">{errors.ugPercentage}</span>}
                  </div>
                </div>
              </div>

              {/* Postgraduate (PG) */}
              <div className="education-level-card">
                <h4>2. Postgraduate (PG) Degree (Optional)</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Degree Name</label>
                    <input
                      type="text"
                      name="pgDegree"
                      value={formData.pgDegree}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="e.g. M.Sc, M.A, M.Ed"
                    />
                  </div>

                  <div className="form-group">
                    <label>University / College</label>
                    <input
                      type="text"
                      name="pgUniversity"
                      value={formData.pgUniversity}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="University Name"
                    />
                  </div>
                </div>

                <div className="form-row three-cols">
                  <div className="form-group">
                    <label>Medium</label>
                    <select
                      name="pgMedium"
                      value={formData.pgMedium}
                      onChange={handleInputChange}
                      className="form-select-custom"
                    >
                      <option value="English">English</option>
                      <option value="Tamil">Tamil</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Year of Passing</label>
                    <input
                      type="number"
                      name="pgYearOfPassing"
                      value={formData.pgYearOfPassing}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="YYYY"
                      min="1970"
                      max={new Date().getFullYear()}
                    />
                  </div>
                  <div className="form-group">
                    <label>Percentage / CGPA</label>
                    <input
                      type="number"
                      step="0.01"
                      name="pgPercentage"
                      value={formData.pgPercentage}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="e.g. 82.0"
                    />
                  </div>
                </div>
              </div>

              {/* 12th Standard */}
              <div className="education-level-card">
                <h4>3. Class 12 (Higher Secondary) <span className="req-star">*</span></h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Board / Council <span className="req-star">*</span></label>
                    <input
                      type="text"
                      name="class12School"
                      value={formData.class12School}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.class12School ? 'input-error' : ''}`}
                      placeholder="e.g. CBSE, State Board, ICSE"
                    />
                    {errors.class12School && <span className="error-message">{errors.class12School}</span>}
                  </div>

                  <div className="form-group">
                    <label>School Name <span className="req-star">*</span></label>
                    <input
                      type="text"
                      name="class12Institute"
                      value={formData.class12Institute}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.class12Institute ? 'input-error' : ''}`}
                      placeholder="School Name"
                    />
                    {errors.class12Institute && <span className="error-message">{errors.class12Institute}</span>}
                  </div>
                </div>

                <div className="form-row three-cols">
                  <div className="form-group">
                    <label>Medium <span className="req-star">*</span></label>
                    <select
                      name="class12Medium"
                      value={formData.class12Medium}
                      onChange={handleInputChange}
                      className="form-select-custom"
                    >
                      <option value="English">English</option>
                      <option value="Tamil">Tamil</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Year of Passing <span className="req-star">*</span></label>
                    <input
                      type="number"
                      name="class12YearOfPassing"
                      value={formData.class12YearOfPassing}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.class12YearOfPassing ? 'input-error' : ''}`}
                      placeholder="YYYY"
                    />
                    {errors.class12YearOfPassing && <span className="error-message">{errors.class12YearOfPassing}</span>}
                  </div>
                  <div className="form-group">
                    <label>Percentage <span className="req-star">*</span></label>
                    <input
                      type="number"
                      step="0.01"
                      name="class12Percentage"
                      value={formData.class12Percentage}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.class12Percentage ? 'input-error' : ''}`}
                      placeholder="e.g. 85.0"
                    />
                    {errors.class12Percentage && <span className="error-message">{errors.class12Percentage}</span>}
                  </div>
                </div>
              </div>

              {/* 10th Standard */}
              <div className="education-level-card">
                <h4>4. Class 10 (Secondary) <span className="req-star">*</span></h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Board / Council <span className="req-star">*</span></label>
                    <input
                      type="text"
                      name="class10School"
                      value={formData.class10School}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.class10School ? 'input-error' : ''}`}
                      placeholder="e.g. CBSE, State Board"
                    />
                    {errors.class10School && <span className="error-message">{errors.class10School}</span>}
                  </div>

                  <div className="form-group">
                    <label>School Name <span className="req-star">*</span></label>
                    <input
                      type="text"
                      name="class10Institute"
                      value={formData.class10Institute}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.class10Institute ? 'input-error' : ''}`}
                      placeholder="School Name"
                    />
                    {errors.class10Institute && <span className="error-message">{errors.class10Institute}</span>}
                  </div>
                </div>

                <div className="form-row three-cols">
                  <div className="form-group">
                    <label>Medium <span className="req-star">*</span></label>
                    <select
                      name="class10Medium"
                      value={formData.class10Medium}
                      onChange={handleInputChange}
                      className="form-select-custom"
                    >
                      <option value="English">English</option>
                      <option value="Tamil">Tamil</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Year of Passing <span className="req-star">*</span></label>
                    <input
                      type="number"
                      name="class10YearOfPassing"
                      value={formData.class10YearOfPassing}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.class10YearOfPassing ? 'input-error' : ''}`}
                      placeholder="YYYY"
                    />
                    {errors.class10YearOfPassing && <span className="error-message">{errors.class10YearOfPassing}</span>}
                  </div>
                  <div className="form-group">
                    <label>Percentage <span className="req-star">*</span></label>
                    <input
                      type="number"
                      step="0.01"
                      name="class10Percentage"
                      value={formData.class10Percentage}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.class10Percentage ? 'input-error' : ''}`}
                      placeholder="e.g. 90.0"
                    />
                    {errors.class10Percentage && <span className="error-message">{errors.class10Percentage}</span>}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ================= STEP 3: WORK EXPERIENCE & REFERENCES ================= */}
          {currentStep === 3 && (
            <div className="form-section-card">
              <div className="section-legend-box">
                <div className="section-icon">💼</div>
                <div className="section-heading-text">
                  <h3>Step 3: Work Experience & Professional References</h3>
                  <p>Document previous teaching experience, salary expectations, and references</p>
                </div>
              </div>

              {/* Dynamic Work Experience Cards */}
              <div className="highlight-card">
                <h4 className="highlight-card-title">Previous Teaching / Professional Experience</h4>
                {workExperience.map((exp, index) => (
                  <div key={exp.id} className="work-experience-card">
                    <div className="work-experience-header">
                      <h4>Experience #{index + 1}</h4>
                      {workExperience.length > 1 && (
                        <button
                          type="button"
                          className="btn-remove-exp"
                          onClick={() => removeWorkExperience(exp.id)}
                        >
                          ✕ Remove
                        </button>
                      )}
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Institution / School Name</label>
                        <input
                          type="text"
                          value={exp.institutionName}
                          onChange={e => handleWorkExperienceChange(exp.id, 'institutionName', e.target.value)}
                          className="form-control-custom"
                          placeholder="e.g. St. Joseph Matriculation"
                        />
                      </div>
                      <div className="form-group">
                        <label>Designation</label>
                        <input
                          type="text"
                          value={exp.designation}
                          onChange={e => handleWorkExperienceChange(exp.id, 'designation', e.target.value)}
                          className="form-control-custom"
                          placeholder="e.g. PRT Maths Teacher"
                        />
                      </div>
                    </div>

                    <div className="form-row three-cols">
                      <div className="form-group">
                        <label>From Date</label>
                        <input
                          type="date"
                          value={exp.fromDate}
                          onChange={e => handleWorkExperienceChange(exp.id, 'fromDate', e.target.value)}
                          className="form-control-custom"
                        />
                      </div>
                      <div className="form-group">
                        <label>To Date</label>
                        <input
                          type="date"
                          value={exp.toDate}
                          onChange={e => handleWorkExperienceChange(exp.id, 'toDate', e.target.value)}
                          className="form-control-custom"
                        />
                      </div>
                      <div className="form-group">
                        <label>Total Experience (Years)</label>
                        <input
                          type="text"
                          value={exp.years ? `${exp.years} Yrs` : ''}
                          readOnly
                          className="form-control-custom"
                          placeholder="Auto-calculated"
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group full-width">
                        <label>Reason for Leaving</label>
                        <input
                          type="text"
                          value={exp.reasonForLeaving}
                          onChange={e => handleWorkExperienceChange(exp.id, 'reasonForLeaving', e.target.value)}
                          className="form-control-custom"
                          placeholder="e.g. Career progression, Relocation"
                        />
                      </div>
                    </div>
                  </div>
                ))}

                <button type="button" className="btn-add-exp" onClick={addWorkExperience}>
                  + Add Another Teaching Experience
                </button>
              </div>

              {/* Statutory & Salary Details */}
              <div className="highlight-card">
                <h4 className="highlight-card-title">Salary & Statutory Numbers</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Last Drawn Monthly Salary (₹)</label>
                    <input
                      type="number"
                      name="lastDrawnSalary"
                      value={formData.lastDrawnSalary}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="e.g. 25000"
                    />
                  </div>
                  <div className="form-group">
                    <label>Expected Monthly Salary (₹) <span className="req-star">*</span></label>
                    <input
                      type="number"
                      name="expectedSalary"
                      value={formData.expectedSalary}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.expectedSalary ? 'input-error' : ''}`}
                      placeholder="e.g. 30000"
                    />
                    {errors.expectedSalary && <span className="error-message">{errors.expectedSalary}</span>}
                  </div>
                </div>

                <div className="form-row three-cols">
                  <div className="form-group">
                    <label>Previous UAN No</label>
                    <input
                      type="text"
                      name="previousSchoolUANNO"
                      value={formData.previousSchoolUANNO}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="12 digit UAN"
                    />
                  </div>
                  <div className="form-group">
                    <label>Previous ESI No</label>
                    <input
                      type="text"
                      name="previousSchoolESINo"
                      value={formData.previousSchoolESINo}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="ESI Number"
                    />
                  </div>
                  <div className="form-group">
                    <label>Expected Joining Date <span className="req-star">*</span></label>
                    <input
                      type="date"
                      name="expectedDateofJoining"
                      value={formData.expectedDateofJoining}
                      onChange={handleInputChange}
                      className={`form-control-custom ${errors.expectedDateofJoining ? 'input-error' : ''}`}
                    />
                    {errors.expectedDateofJoining && <span className="error-message">{errors.expectedDateofJoining}</span>}
                  </div>
                </div>
              </div>

              {/* References */}
              <div className="highlight-card">
                <h4 className="highlight-card-title">Professional References</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Reference 1: Full Name</label>
                    <input
                      type="text"
                      name="reference1Name"
                      value={formData.reference1Name}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="Name of Principal / Head of Dept"
                    />
                  </div>
                  <div className="form-group">
                    <label>Reference 1: Contact Number</label>
                    <input
                      type="tel"
                      name="reference1ContactNo"
                      value={formData.reference1ContactNo}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="10 digit contact number"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Reference 2: Full Name</label>
                    <input
                      type="text"
                      name="reference2Name"
                      value={formData.reference2Name}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="Second reference person name"
                    />
                  </div>
                  <div className="form-group">
                    <label>Reference 2: Contact Number</label>
                    <input
                      type="tel"
                      name="reference2ContactNo"
                      value={formData.reference2ContactNo}
                      onChange={handleInputChange}
                      className="form-control-custom"
                      placeholder="10 digit contact number"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ================= STEP 4: DOCUMENT UPLOADS & ATTACHMENTS ================= */}
          {currentStep === 4 && (
            <div className="form-section-card">
              <div className="section-legend-box">
                <div className="section-icon">📁</div>
                <div className="section-heading-text">
                  <h3>Step 4: Document Uploads & Previews</h3>
                  <p>Upload digital copies of your photograph and verified certificates (Max 5MB each)</p>
                </div>
              </div>

              <div className="documents-grid">
                {/* 1. Candidate Photo Upload */}
                <div className={`doc-upload-box ${files.userPhoto ? 'has-file' : ''}`}>
                  <div className="doc-icon">📸</div>
                  <div className="doc-title">Applicant Photograph <span className="req-star">*</span></div>
                  <div className="doc-hint">JPG or PNG (Passport size preferred)</div>

                  {photoPreviewUrl && (
                    <div className="photo-preview-box">
                      <img src={photoPreviewUrl} alt="Applicant Preview" />
                    </div>
                  )}

                  <input
                    type="file"
                    id="file-userPhoto"
                    accept="image/jpeg,image/png,image/jpg"
                    onChange={e => handleFileChange(e, 'userPhoto')}
                    className="file-input-hidden"
                  />
                  <label htmlFor="file-userPhoto" className="btn-choose-file">
                    {files.userPhoto ? 'Change Photo' : 'Select Photo'}
                  </label>

                  {fileNames.userPhoto && (
                    <div className="uploaded-file-badge">
                      <span>✓ {fileNames.userPhoto}</span>
                      <button type="button" className="btn-del-file" onClick={() => removeFile('userPhoto')}>✕</button>
                    </div>
                  )}
                  {errors.userPhoto && <span className="error-message">{errors.userPhoto}</span>}
                </div>

                {/* 2. Aadhar Card Copy */}
                <div className={`doc-upload-box ${files.aadharCopy ? 'has-file' : ''}`}>
                  <div className="doc-icon">🆔</div>
                  <div className="doc-title">Aadhar Card Copy <span className="req-star">*</span></div>
                  <div className="doc-hint">PDF or Image of Aadhar front & back</div>

                  <input
                    type="file"
                    id="file-aadharCopy"
                    accept=".pdf,image/jpeg,image/png,image/jpg"
                    onChange={e => handleFileChange(e, 'aadharCopy')}
                    className="file-input-hidden"
                  />
                  <label htmlFor="file-aadharCopy" className="btn-choose-file">
                    {files.aadharCopy ? 'Change File' : 'Select Aadhar'}
                  </label>

                  {fileNames.aadharCopy && (
                    <div className="uploaded-file-badge">
                      <span>✓ {fileNames.aadharCopy}</span>
                      <button type="button" className="btn-del-file" onClick={() => removeFile('aadharCopy')}>✕</button>
                    </div>
                  )}
                  {errors.aadharCopy && <span className="error-message">{errors.aadharCopy}</span>}
                </div>

                {/* 3. UG Degree Certificate */}
                <div className={`doc-upload-box ${files.ugCertificate ? 'has-file' : ''}`}>
                  <div className="doc-icon">📜</div>
                  <div className="doc-title">Undergraduate (UG) Degree <span className="req-star">*</span></div>
                  <div className="doc-hint">PDF or Image of Degree Certificate / Marksheet</div>

                  <input
                    type="file"
                    id="file-ugCertificate"
                    accept=".pdf,image/jpeg,image/png,image/jpg"
                    onChange={e => handleFileChange(e, 'ugCertificate')}
                    className="file-input-hidden"
                  />
                  <label htmlFor="file-ugCertificate" className="btn-choose-file">
                    {files.ugCertificate ? 'Change File' : 'Select UG Cert'}
                  </label>

                  {fileNames.ugCertificate && (
                    <div className="uploaded-file-badge">
                      <span>✓ {fileNames.ugCertificate}</span>
                      <button type="button" className="btn-del-file" onClick={() => removeFile('ugCertificate')}>✕</button>
                    </div>
                  )}
                  {errors.ugCertificate && <span className="error-message">{errors.ugCertificate}</span>}
                </div>

                {/* 4. B.Ed Certificate */}
                <div className={`doc-upload-box ${files.bedCertificate ? 'has-file' : ''}`}>
                  <div className="doc-icon">🎓</div>
                  <div className="doc-title">B.Ed / Teaching Certificate (Optional)</div>
                  <div className="doc-hint">PDF or Image of B.Ed / TET Certificate</div>

                  <input
                    type="file"
                    id="file-bedCertificate"
                    accept=".pdf,image/jpeg,image/png,image/jpg"
                    onChange={e => handleFileChange(e, 'bedCertificate')}
                    className="file-input-hidden"
                  />
                  <label htmlFor="file-bedCertificate" className="btn-choose-file">
                    {files.bedCertificate ? 'Change File' : 'Select Certificate'}
                  </label>

                  {fileNames.bedCertificate && (
                    <div className="uploaded-file-badge">
                      <span>✓ {fileNames.bedCertificate}</span>
                      <button type="button" className="btn-del-file" onClick={() => removeFile('bedCertificate')}>✕</button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ================= STEP 5: REVIEW, DECLARATION & PAYMENT ================= */}
          {currentStep === 5 && (
            <div className="form-section-card">
              <div className="section-legend-box">
                <div className="section-icon">✅</div>
                <div className="section-heading-text">
                  <h3>Step 5: Review Application & Secure Checkout</h3>
                  <p>Verify your filled information and finalize PhonePe payment</p>
                </div>
              </div>

              {/* Review Summary Table */}
              <div className="review-summary-card">
                <div className="review-summary-header">
                  <h4>Application Summary</h4>
                </div>
                <table className="review-table">
                  <tbody>
                    <tr>
                      <td className="label-col">Post & Subject Applied:</td>
                      <td className="val-col">{formData.appliedPost} - {formData.appliedSubject}</td>
                    </tr>
                    <tr>
                      <td className="label-col">Applicant Name:</td>
                      <td className="val-col">{formData.applicantName} ({formData.gender})</td>
                    </tr>
                    <tr>
                      <td className="label-col">Email & Mobile:</td>
                      <td className="val-col">{formData.emailID} | +91 {formData.phoneNumber}</td>
                    </tr>
                    <tr>
                      <td className="label-col">Date of Birth & Aadhar:</td>
                      <td className="val-col">{formData.dateOfBirth} | {formData.aadharNo}</td>
                    </tr>
                    <tr>
                      <td className="label-col">Highest Qualification:</td>
                      <td className="val-col">{formData.educationalQualification} ({formData.subject})</td>
                    </tr>
                    <tr>
                      <td className="label-col">Expected Salary:</td>
                      <td className="val-col">₹ {formData.expectedSalary} / month</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Fee Breakdown */}
              <div className="fee-breakdown-card">
                <div className="fee-item">
                  <span>Application Processing Fee</span>
                  <span>₹ 200.00</span>
                </div>
                <div className="fee-item">
                  <span>GST & Gateway Surcharge</span>
                  <span>₹ 0.00</span>
                </div>
                <div className="fee-total">
                  <span>Total Payable Amount</span>
                  <span>₹ 200.00</span>
                </div>
              </div>

              {/* Declaration Checkbox */}
              <div className="declaration-box">
                <label className="declaration-label">
                  <input
                    type="checkbox"
                    name="terms"
                    checked={formData.terms}
                    onChange={handleInputChange}
                    className="declaration-checkbox"
                  />
                  <span>
                    I hereby declare that all information furnished above is true, complete, and correct to the best of my knowledge and belief. I agree to proceed to the secure PhonePe gateway to complete the application registration.
                  </span>
                </label>
                {errors.terms && <span className="error-message">{errors.terms}</span>}
              </div>

              {statusMessage && (
                <div className="form-alert-box form-alert-info">
                  <span>ℹ️ {statusMessage}</span>
                </div>
              )}

              {errorMessage && (
                <div className="form-alert-box form-alert-danger">
                  <span>⚠️ {errorMessage}</span>
                </div>
              )}

              {info && (
                <div className="form-alert-box form-alert-info">
                  <span>ℹ️ {info}</span>
                </div>
              )}
            </div>
          )}

          {/* Stepper Footer Action Buttons */}
          <div className="stepper-actions">
            <div>
              {currentStep > 1 && (
                <button type="button" className="btn-step btn-step-prev" onClick={handlePrevStep}>
                  ← Previous Step
                </button>
              )}
            </div>

            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              <button type="button" className="btn-step btn-step-clear" onClick={resetForm}>
                Reset Form
              </button>

              {currentStep < 5 ? (
                <button type="button" className="btn-step btn-step-next" onClick={handleNextStep}>
                  Save & Continue →
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn-step btn-step-submit"
                  disabled={isInitiatingPhonePe || isProcessingOrder}
                >
                  {isInitiatingPhonePe || isProcessingOrder ? 'Processing...' : 'Pay ₹200 via PhonePe 💳'}
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
